import axiosApi from "axios";
import router from "@/router";
import { ToastTimeoutMS } from "@/utils/constants";
import ToastEventBus from "primevue/toasteventbus";
import i18n from "@/configs/i18n";
import { useAuthStore } from "@/stores/auth";
import PermissionDeniedError from "@/errors/PermissionDeniedError";
import { CurrentBrowserPath, SetRedirectPath } from "@/utils/redirectPath";

export const HandleAxiosError = (error) => {
  if (axiosApi.isCancel(error)) {
    return Promise.reject(error);
  }
  switch (error?.response?.status) {
    case 401:
      useAuthStore().setUserData(null);
      localStorage.removeItem("token");
      // Сохранение адреса не должно мешать уходу на логин: раньше btoa падал
      // на кириллическом пути и до router.push дело не доходило.
      // Адрес берём из window.location - на старте роутер ещё не разрешил
      // первый переход и currentRoute отдал бы "/".
      SetRedirectPath(CurrentBrowserPath());

      return router.push({ name: "login" });
    case 422:
      return Promise.reject(error);
    case 403:
      ToastEventBus.emit("add", {
        severity: "error",
        summary: i18n.global.t("error"),
        detail: i18n.global.t("permission_error", {
          permission: error?.response?.debug
            ? error?.response?.debug?.middleware?.permission
            : (error?.response?.message ?? error?.response?.data?.message),
        }),
        life: ToastTimeoutMS,
      });
      return Promise.reject(
        new PermissionDeniedError(
          error?.response?.debug
            ? error?.response?.debug?.middleware?.permission
            : (error?.response?.message ?? error?.response?.data?.message),
        ),
      );
    default:
      ToastEventBus.emit("add", {
        severity: "error",
        summary: i18n.global.t("error"),
        detail: error?.response?.data?.message || error?.response?.data?.error || error.message,
        life: ToastTimeoutMS,
      });
      return Promise.reject(error);
  }
};
export const HandleAxiosResponse = (response) => {
  return response.data;
};

/**
 * Перехватчик выше сам показывает тост на всё, кроме отмены, 401 (уводит на
 * логин) и 422 (его разбирают формы). Поэтому компонент вправе показать свой
 * тост только на 422 — иначе на одну ошибку пользователь видит два.
 */
export const ShouldToastApiError = (error) => error?.response?.status === 422;

/**
 * 409 - заявку уже перевёл другой запрос (второе нажатие, другой сотрудник).
 * Тост с причиной показал перехватчик; экрану остаётся перечитать данные,
 * иначе он продолжит показывать кнопки под прежний статус.
 */
export const IsConflictError = (error) => error?.response?.status === 409;
